/**
 * Botón para abrir el progreso académico
 * Solo aparece en modo "estudio directo" cuando hay datos de Apolearn
 */

import './AcademicProgressButton.css';

interface AcademicProgressButtonProps {
  onClick: () => void;
  isInProgress?: boolean; // Indica si hay una lección en proceso
}

export function AcademicProgressButton({ onClick, isInProgress = false }: AcademicProgressButtonProps) {
  const buttonText = isInProgress 
    ? 'Progreso en proceso' 
    : 'Avanzar en mi progreso académico';
  
  return (
    <button
      className="academic-progress-button"
      onClick={onClick}
      aria-label={buttonText}
    >
      <img 
        src="/assets/ui/iconos/Progreso.png?v=4" 
        alt="Progreso académico" 
        className="academic-progress-icon"
      />
      <span className="academic-progress-button-text">
        {buttonText}
      </span>
    </button>
  );
}

